import {Model} from "ords/dist/model/model"

export class RubricSection extends  Model{

}

export const RubricSectionConfig = {
    name: 'rubricSection',
    model: RubricSection,
    relations: [
        {name: 'rubric_columns', model_name: 'RubricColumn', type: 'hasMany'},
        {name: 'rubric_rows', model_name: 'RubricRow', type: 'hasMany'},
    ]
}
